/**
 * Decodifica (sin verificar firma) el payload de un JWT -- alcanza para uso
 * de UX porque el servidor valida el access token real de forma
 * independiente (`AdminAuthMiddleware`/`EntraTokenValidator`, C#). Nunca
 * usar el resultado para decidir algo que dependa de seguridad real.
 */
export function decodeJwtPayload(token: string): Record<string, unknown> | undefined {
  const segments = token.split(".");
  const payload = segments[1];
  if (segments.length !== 3 || payload === undefined) {
    return undefined;
  }

  try {
    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
    const binary = atob(padded);
    const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
    return JSON.parse(new TextDecoder("utf-8").decode(bytes)) as Record<string, unknown>;
  } catch {
    return undefined;
  }
}
